import { apiClient, getActivePvzId, isSupabaseConfigured } from './_shared.js'

export async function getDeductions(start, end, pvzIdParam = null) {
  if (!isSupabaseConfigured) return []
  const pvzId = pvzIdParam || getActivePvzId()
  if (!pvzId) return []
  
  const params = new URLSearchParams()
  params.append('pvzId', pvzId)
  params.append('startDate', start)
  params.append('endDate', end)

  let data = await apiClient('/deductions?' + params.toString())
  return data.map(item => ({ ...item, date: item.date?.split('T')[0] }))
}

export async function getMyDeductions(start, end) {
  if (!isSupabaseConfigured) return []
  const params = new URLSearchParams()
  if (start) params.append('start', start)
  if (end) params.append('end', end)
  
  let data = await apiClient('/deductions/my?' + params.toString())
  return data.map(item => ({ ...item, date: item.date?.split('T')[0] }))
}

export async function addDeduction(data) {
  if (!isSupabaseConfigured) return null
  const payload = {
    pvz_id: getActivePvzId(),
    employee_id: data.employee_id,
    type: data.type,
    amount: Number(data.amount),
    comment: data.comment,
    video_url: data.video_url,
    date: data.date
  }
  return await apiClient('/deductions', {
    method: 'POST',
    body: JSON.stringify(payload)
  })
}

export async function updateDeduction(id, data) {
  if (!isSupabaseConfigured) return null
  const payload = {
    employee_id: data.employee_id,
    type: data.type,
    amount: Number(data.amount),
    comment: data.comment,
    video_url: data.video_url,
    date: data.date
  }
  return await apiClient(`/deductions/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  })
}

export async function deleteDeduction(id) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/deductions/${id}`, {
    method: 'DELETE'
  })
}

export async function clearRejectedDeductions() {
  if (!isSupabaseConfigured) return null
  return await apiClient('/deductions/rejected', {
    method: 'DELETE'
  })
}

export async function disputeDeduction(id, comment, evidenceUrl = null, disputeVideoUrl = null) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/deductions/${id}/dispute`, {
    method: 'PUT',
    body: JSON.stringify({
      comment,
      evidence_url: evidenceUrl,
      dispute_video_url: disputeVideoUrl
    })
  })
}

export async function resolveDeductionDispute(id, isApproved) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/deductions/${id}/resolve`, {
    method: 'PUT',
    body: JSON.stringify({ isApproved })
  })
}
